document.addEventListener('DOMContentLoaded',function(){
  var giftcancel = document.querySelector(".giftcancel");
  var giftbox = document.getElementById("giftbox");
  var giftbtn = document.getElementById("giftbtn");
  console.log("giftbtn",giftbtn);
  giftbtn.addEventListener("click",function(){
    console.log("OK",giftbox);
    giftbox.style.display = "block";
  });
    giftcancel.addEventListener("click",function(e){
    giftbox.style.display = "none";
  }); 
  
 })

//  document.addEventListener('DOMContentLoaded', function() {
//   function applyVariantFromURL() {
//     const urlParams = new URLSearchParams(window.location.search);
//     const variantId = urlParams.get('variant');
    
//     if (variantId) {
//       const hiddenSelect = document.querySelector('select.original-selector[name="id"]');
//       if (hiddenSelect) {

//         const optionToSelect = hiddenSelect.querySelector(`option[value="${variantId}"]`);
        
//         if (optionToSelect) {
//           hiddenSelect.value = variantId;
          
//           const variant = window.theme?.product?.variants?.find(v => v.id == variantId);
//           if (variant) {
//             variant.options.forEach((optionValue, index) => {
//               const selector = document.querySelector(`#option-${window.theme?.product?.options[index]?.handle || 'option-' + index}-${window.theme?.product?.id || ''}`);
//               if (selector) {
//                 selector.value = optionValue;
//                 selector.dispatchEvent(new Event('change', { bubbles: true }));
//               }
//             });
//           }
//         }
//       }
//     }
//   }
  
//   applyVariantFromURL();
  
//   setTimeout(applyVariantFromURL, 500);
// });